export enum processEventStateTypes {
  updating = 0,
  completed = 1,
}
